import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import StringRen from "csi/heading/String";
import html from "csi/html";
import locale from "csi/locale";
import MessageDialog from "csi/widget/MessageDialog";
import TextWithMaterialIcon from "csi/widget/TextWithMaterialIcon";
import declare from "dojo/_base/declare";

const DetailedStatusMessageRenderer = declare(StringRen, {

	/**
	 * @override
	 * This method displays an error icon alongside a message when document generation fails from DGaaS WS
	 * Upon clicking the error icon, a detailed error message is shown, which is derived from the DetailedStatusMessage attribute.
	 */
	toHtmlStatic(ctx: Context, _h: Heading, refNode: HTMLElement): boolean {
		const node = ctx.getNode();

		// in the case of proofing example setting view, the node doesn't exist
		const statusMessage = node?.StatusMessage;
		const detailedStatusMessage = node?.DetailedStatusMessage;

		if (detailedStatusMessage) {
			new TextWithMaterialIcon({
				icon: "error",
				text: statusMessage,
				class: "csi-file-state-error",
				onClick: (): void => {
					const dlg = new MessageDialog({
						destroyOnHide: false,
						buttons: [MessageDialog.BUTTON_CLOSE],
						message: detailedStatusMessage,
						materialIcon: MessageDialog.ICON_ERROR,
						title: locale.resource("DocumentGenerationFailed"),
					});
					dlg.show();
				},
			}).placeAt(refNode);

			/*
			 * Hide the first child element of the parent node.
			 * If there is a DGaaS file generation error, it will display only the error message.
			 * The first element within the File column contains the filename, while the second element contains the error message.
			 * targets elements with the CSS classes .csi-table-row, .attrUrl, and .attrPrimary.
			 */
			html.hide(refNode.parentElement.firstChild);

			return true;
		}

		return this.inherited<boolean>(arguments);
	},
});

export = DetailedStatusMessageRenderer;